import Context from './index';
import React, { useState } from 'react';

const JobSearchProvider = (props) => {
    const [jobData] = useState([]);
    const [searchData] = useState([]);

    return (
        <Context.Provider
            value={{
                ...props,
                jobData,
                searchData
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default JobSearchProvider;